<div class="alert-container" *ngIf="data">
  <div class="alert" [ngClass]="{ 'alert-success': !data.error, 'alert-danger': data.error }">
    <div class="alert_heading">{{data.message?.title}} </div>
    <div *ngIf="data.message.detail" class="alert_detail">{{data.message?.detail}}</div>
  </div>
</div>
<div class="newCall-alert" *ngIf="newCallData">
  <div class="alert">
    <span>{{newCallData?.message?.count > 10? newCallData?.message?.count: '0'+newCallData?.message?.count}}</span>
    <p>New {{newCallData?.message?.category | callCategory}} Call{{newCallData?.message?.count > 1? 's': ''}} Added</p>
  </div>
</div>
